export class OfficeCatchmentEditModel{
    divisionId:number;
    districtId:number;
    upazillaId:number;
    unionId:number;
}